import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table-default payments--table"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "text-semi-bold" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["src"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "payment-reference"
}
const _hoisted_11 = { colspan: "5" }
const _hoisted_12 = { class: "text" }
const _hoisted_13 = { class: "text" }
const _hoisted_14 = {
  key: 1,
  class: "spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tippy = _resolveDirective("tippy")!

  return (!$setup.loading)
    ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", { class: "no-padding" }, "Lot"),
            _createElementVNode("th", null, "Amount"),
            _createElementVNode("th", null, "Transaction date"),
            _createElementVNode("th", null, "Status")
          ])
        ], -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.invoices, (item, index) => {
          return (_openBlock(), _createElementBlock("tbody", {
            key: item.lotId
          }, [
            _createElementVNode("tr", {
              onClick: ($event: any) => (item.showPaymentReference = $setup.checkFundsClearedReportAndStatus(item.fundsClearedReport, item?.transactionStatus) ? !item.showPaymentReference : false)
            }, [
              _createElementVNode("td", _hoisted_3, "Lot " + _toDisplayString(item?.lotTitle), 1),
              _createElementVNode("td", _hoisted_4, _toDisplayString($setup.formatStripePrice(item?.depositAmount)), 1),
              _createElementVNode("td", _hoisted_5, _toDisplayString($setup.dayjs(item?.transactionTime).format("D MMM YYYY, hh:mm A")), 1),
              _createElementVNode("td", null, [
                _createElementVNode("div", {
                  class: _normalizeClass(["badge", $setup.getInvoiceStatusClass(item?.transactionStatus)])
                }, [
                  _createTextVNode(_toDisplayString(item?.transactionStatus), 1),
                  _withDirectives(_createElementVNode("img", {
                    src: require('@/assets/icons/icon-info.svg'),
                    alt: "icon"
                  }, null, 8, _hoisted_6), [
                    [_directive_tippy, { content: $setup.getTooltipText(item?.transactionStatus), theme: 'light-border', placement: 'top' }]
                  ])
                ], 2)
              ]),
              ($setup.checkFundsClearedReportAndStatus(item.fundsClearedReport, item?.transactionStatus))
                ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
                    _createElementVNode("img", {
                      class: _normalizeClass(["arrow-right", { rotated: item.showPaymentReference }]),
                      src: require('@/assets/icons/icon-arrow-right.svg')
                    }, null, 10, _hoisted_8)
                  ]))
                : (_openBlock(), _createElementBlock("td", _hoisted_9))
            ], 8, _hoisted_2),
            (item.showPaymentReference)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                  _createElementVNode("td", _hoisted_11, [
                    _createElementVNode("div", null, [
                      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-semi-bold" }, "Funds cleared:", -1)),
                      _createElementVNode("div", _hoisted_12, _toDisplayString($setup.dayjs(item.fundsClearedReport?.fundsClearedDate).format("D MMM YYYY")), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-semi-bold" }, "Payment reference:", -1)),
                      _createElementVNode("div", _hoisted_13, _toDisplayString(item.fundsClearedReport.remitter) + " " + _toDisplayString(item.fundsClearedReport.bankReference) + " " + _toDisplayString(item.fundsClearedReport.description), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_14))
}